<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'fuelsale',
      breadcrumb: [
        { name: "加油站管理", path: '/oilStation/fuelSales' },
        { name: "燃油销售", path: '/oilStation/fuelSales' },
        { name: "销售列表" },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "",
          keyName: "oid",
          placeholder: "请填写查询订单",
          type: "text",
        },
      ],
      cols: [
        { prop: "oid", label: "订单编号" },
        { prop: "money", label: "金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "fuelnum", label: "加油量/升", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "addtime", label: "时间" },
      ],
      getListUrl: 'findrecord',
      baseParams: ['license'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
